enum AppointmentResourceConfigurationQueryBy {
  COUNTRY = 'COUNTRY',
  SHOP = 'SHOP',
}

export { AppointmentResourceConfigurationQueryBy }
